// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-page{grid-column-gap:10px;width:87%;padding-bottom:80px}.grid-page>*{min-width:0}@media (min-width:768px){.grid-page{grid-gap:20px;padding-bottom:1.25rem}#grid-layout-content{box-shadow:0 2px 7px 0 rgba(0,0,0,.18);background-color:#fafbfc;margin-left:250px}}", ""]);
// Exports
module.exports = exports;
